import React from 'react';
import { AppButton } from './AppButton';
import { AppModal } from './AppModal';

/**
 * ConfirmDialog — asks before a destructive action, in place of
 * window.confirm. `busy` disables both buttons while the action runs.
 */
export const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  busy = false,
}) => (
  <AppModal
    open={open}
    onClose={busy ? undefined : onCancel}
    title={title}
    maxWidth="440px"
    footer={(
      <div className="flex justify-end gap-2">
        <AppButton variant="ghost" onClick={onCancel} disabled={busy}>Cancel</AppButton>
        <AppButton variant="danger" onClick={onConfirm} loading={busy}>{confirmLabel}</AppButton>
      </div>
    )}
  >
    <p className="m-0 text-[14px] text-lb-ink leading-[1.5]">{message}</p>
  </AppModal>
);
